import { useEffect, useState, useCallback } from "react";
import {
  useGetCountriesMutation,
  useGetStatesMutation,
  useGetCitiesMutation
} from "../../store/app/country.api";

export const useGeniusGeo = () => {
  const [getCountries] = useGetCountriesMutation();
  const [getStates] = useGetStatesMutation();
  const [getCities] = useGetCitiesMutation();
  const [indiaCountryId, setIndiaCountryId] = useState(null);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const result = await getCountries();
        const list = result?.data || [];
        const india =
          list.find((c) => c.country_name?.toLowerCase() === "india") || list[0];
        if (india?.country_id) {
          setIndiaCountryId(india.country_id);
        }
      } catch (e) {
        console.error("Failed to load countries", e);
      }
    };
    load();
  }, [getCountries]);

  const loadStates = useCallback(async () => {
    if (!indiaCountryId) return;
    setLoadingStates(true);
    try {
      const result = await getStates({ country: indiaCountryId });
      setStates(
        (result?.data || []).map(({ state_id, state_name }) => ({
          id: String(state_id),
          name: state_name,
          value: state_name
        }))
      );
    } catch (e) {
      console.error("Failed to load states", e);
      setStates([]);
    } finally {
      setLoadingStates(false);
    }
  }, [getStates, indiaCountryId]);

  useEffect(() => {
    if (indiaCountryId) loadStates();
  }, [indiaCountryId, loadStates]);

  const loadCitiesForState = useCallback(
    async (stateName) => {
      if (!indiaCountryId || !stateName) {
        setCities([]);
        return;
      }

      const stateMatch = states.find((s) => s.value === stateName || s.name === stateName);
      if (!stateMatch?.id) {
        setCities([]);
        return;
      }

      setLoadingCities(true);
      try {
        const result = await getCities({
          country: indiaCountryId,
          state: stateMatch.id
        });
        setCities(
          (result?.data || []).map(({ district_id, district_name }) => ({
            id: String(district_id),
            name: district_name,
            value: district_name
          }))
        );
      } catch (e) {
        console.error("Failed to load cities for state", stateName, e);
        setCities([]);
      } finally {
        setLoadingCities(false);
      }
    },
    [getCities, indiaCountryId, states]
  );

  return {
    indiaCountryId,
    states,
    cities,
    loadingStates,
    loadingCities,
    loadCitiesForState,
    countryLabel: "India"
  };
};
